import { openBlock as t, createElementBlock as o, createElementVNode as c } from "vue";
const e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, h = /* @__PURE__ */ c("path", {
  fill: "currentColor",
  d: "M5.833 7.292h-2.5A2.29 2.29 0 0 1 1.042 5V3.333a2.29 2.29 0 0 1 2.291-2.291h2.5a2.29 2.29 0 0 1 2.292 2.291V5a2.29 2.29 0 0 1-2.292 2.292m-2.5-5a1.04 1.04 0 0 0-1.041 1.041V5c0 .575.466 1.042 1.041 1.042h2.5c.575 0 1.042-.467 1.042-1.042V3.333c0-.575-.467-1.041-1.042-1.041zm14.001 4.166h-3c-.9 0-1.625-.733-1.625-1.625V3.5c0-.9.733-1.625 1.625-1.625h3c.9 0 1.625.733 1.625 1.625v1.333c0 .9-.726 1.625-1.625 1.625m-3-3.333c-.2 0-.375.175-.375.375v1.333c0 .2.175.375.375.375h3c.2 0 .375-.175.375-.375V3.5c0-.2-.175-.375-.375-.375zm3 9.583h-3c-.9 0-1.625-.733-1.625-1.625V9.75c0-.9.733-1.625 1.625-1.625h3c.9 0 1.625.733 1.625 1.625v1.333c0 .9-.726 1.625-1.625 1.625m-3-3.333c-.2 0-.375.175-.375.375v1.333c0 .2.175.375.375.375h3c.2 0 .375-.175.375-.375V9.75c0-.2-.175-.375-.375-.375z"
}, null, -1), l = /* @__PURE__ */ c("path", {
  fill: "currentColor",
  d: "M13.333 4.792H7.5a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h5.833a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625"
}, null, -1), n = /* @__PURE__ */ c("path", {
  fill: "currentColor",
  d: "M13.333 17.292h-1.25A2.29 2.29 0 0 1 9.791 15V4.167a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625V15c0 .575.467 1.042 1.042 1.042h1.25a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625"
}, null, -1), r = /* @__PURE__ */ c("path", {
  fill: "currentColor",
  d: "M13.333 11.042h-2.917a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h2.917a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625m4.001 7.916h-3c-.9 0-1.625-.733-1.625-1.625V16c0-.9.733-1.625 1.625-1.625h3c.9 0 1.625.733 1.625 1.625v1.333c0 .9-.726 1.625-1.625 1.625m-3-3.333c-.2 0-.375.175-.375.375v1.333c0 .2.175.375.375.375h3c.2 0 .375-.175.375-.375V16c0-.2-.175-.375-.375-.375z"
}, null, -1), a = [
  h,
  l,
  n,
  r
];
function s(d, i) {
  return t(), o("svg", e, [...a]);
}
const V = { render: s };
export {
  V as default,
  s as render
};
